export const COLOR = {
  primary: '#0552F0',
  primaryDark: '#0440C0',
  primaryLight: '#EEF3FE',
  primaryBorder: '#CFE0FE',
  primaryBorderStrong: '#B9CEFB',
  navy: '#171D4A',
  text: '#111827',
  textSecondary: '#6B7280',
  textMuted: '#9CA3AF',
  border: '#E5E7EB',
  surface: '#FFFFFF',
  pageBackground: '#F9FAFB',
  mutedBackground: '#F3F4F6',
  error: '#EF4444',
  errorText: '#B91C1C',
  errorBackground: '#FEF2F2',
  errorBorder: '#FCA5A5',
  success: '#10B981',
  successBackground: '#ECFDF5',
  warning: '#F59E0B',
  warningText: '#92400E',
  warningBackground: '#FFFBEB',
};

export const SPACING = {
  xs: '4px',
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '20px',
  xxl: '24px',
  xxxl: '32px',
};

export const RADIUS = {
  sm: '4px',
  md: '6px',
  card: '8px',
  modal: '10px',
  pill: '20px',
};

export const SHADOW = {
  card: '0 1px 4px rgba(0, 0, 0, 0.06)',
  actionBar: '0 -2px 12px rgba(0, 0, 0, 0.08)',
};

export const FONT_SIZE = {
  pageTitle: '20px',
  cardTitle: '16px',
  sectionTitle: '12px',
  body: '13px',
  label: '13px',
  value: '14px',
  amount: '19px',
  hint: '11.5px',
  stepLabel: '11px',
};

export const LAYOUT = {
  maxWidth: '740px',
  gutter: '16px',
};
